export default __webpack_public_path__ + "static/media/abhi-logo.6727f6ab.jpg";